import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

function isLikelyUniqueCode(segment) {
  if (!segment || segment.length < 8) return false;
  if (segment === 'favicon.ico' || segment.includes('.')) return false;
  return true;
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
      meta: { title: '短信链接' },
    },
    {
      path: '/:uniqueCode',
      name: 'Redirect',
      component: () => import('../views/Redirect.vue'),
      props: true,
      beforeEnter: (to, from, next) => {
        const code = to.params.uniqueCode;
        if (!isLikelyUniqueCode(code)) {
          next({ name: 'Home', replace: true });
          return;
        }
        next();
      },
    },
  ],
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
